import React from 'react';

import { useSelector } from 'bundles/research/index/store/hooks';

import EdgeCrm from './edge_crm';
import LiteCrm from './lite_crm';

export default function PropertiesIndexHeader({ ...props }) {
  const edgeCrm = useSelector(state => state.features.edgeCrm);
  const Component = edgeCrm ? EdgeCrm : LiteCrm;
  return <Component {...props} />;
}
